import { createStyles, makeStyles } from '@material-ui/core';
var useStyles = makeStyles(function (theme) {
    var _a;
    return createStyles({
        card: (_a = {
                display: 'flex',
                borderRadius: '0.625rem',
                boxShadow: 'var(--box-shadow)',
                background: 'var(--blanco)',
                zIndex: 1
            },
            _a[theme.breakpoints.down('sm')] = {
                borderRadius: '0',
            },
            _a),
    });
});
export default useStyles;
